import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { BaseFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { fetchRecall } from 'queries/operations/recall'
import { useEssentials } from 'hooks/utils/useEssentials'
import { useAnalytics } from 'utils/analytics'

export function useRecall({ env, accessToken, filters }: BaseFetchProps) {
    const { currentLocation } = useEssentials()
    const { trackEvent } = useAnalytics()

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.OPERATIONS_RECALL, currentLocation],
        () =>
            fetchRecall({
                env,
                accessToken,
                filters,
                trackEvent,
            }),
        {
            staleTime: 0,
            refetchInterval: TIME.tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
